export const SORTING_OPTIONS = [
  {
    id: 1,
    name: 'Цена (возрастание)',
  },
  {
    id: 2,
    name: 'Цена (убывание)',
  },
  {
    id: 3,
    name: 'Новое',
  }
]

export const MAX_PRICE = 1000000
export const MIN_PRICE = 1000

// nginx client_max_body_size / request body limit — whole request, not per file
export const MAX_UPLOAD_REQUEST_SIZE = 30 * 1024 * 1024 // 30 MB
export const MAX_UPLOAD_FILE_SIZE = 2 * 1024 * 1024 // 2 MB per file